$(function ($) {
    $('#create_customer').submit(function(){
      var firstName = $('#create_customer #first_name');
      var lastName = $('#create_customer #last_name');
      var email = $('#create_customer #email');
      var phone = $('#create_customer #Phone');
      var country = $('#create_customer #Country');
      var state = $('#create_customer #State');
      var hotel = $('#create_customer #HotelName');
      var numberOfRooms = $('#create_customer #NumberofRooms');
      var password = $('#create_customer #password');
      var error = 0;
      
      if (!firstName.val()){
        $('+ .error_text',firstName).show();
        error = 1;
      } else {
        $('+ .error_text',firstName).hide();
        error = 0;
      }

      if (!lastName.val()){
        $('+ .error_text',lastName).show();
        error = 1;
      } else {
        $('+ .error_text',lastName).hide();
        error = 0;
      }

      if (!email.val()){
        $('+ .error_text',email).show();
        error = 1;
      } else {
        $('+ .error_text',email).hide();
        error = 0;
      }

      if (!phone.val()){
        $('+ .error_text',phone).show();
        error = 1;
      } else {
        $('+ .error_text',phone).hide();
        error = 0;
      }

      if (!country.val()){
        $('+ .error_text',country).show();
        error = 1;
      } else {
        $('+ .error_text',country).hide();
        error = 0;
      }

      if (!state.val()){
        $('+ .error_text',state).show();
        error = 1;
      } else {
        $('+ .error_text',state).hide();
        error = 0;
      }

      if (!hotel.val()){
        $('+ .error_text',hotel).show();
        error = 1;
      } else {
        $('+ .error_text',hotel).hide();
        error = 0;
      }

      if (!numberOfRooms.val()){
        $('+ .error_text',numberOfRooms).show();
        error = 1;
      } else {
        $('+ .error_text',numberOfRooms).hide();
        error = 0;
      }

      if (!password.val()){
        $('+ .error_text',password).show();
        error = 1;
      } else {
        $('+ .error_text',password).hide();
        error = 0;
      }

      if(!error) {
        return true;
      }
      
      return false;
    });
});